import React from 'react';

// Port of components/base_component.html header block + .green-header /
// .header-subtitle from base_component.css.
export function GreenHeader({ title, subtitle }) {
  return (
    <header className="green-header" role="banner">
      <h1>{title}</h1>
      {subtitle && <p className="header-subtitle">{subtitle}</p>}
    </header>
  );
}

export default GreenHeader;
